/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementAwsStatisticsDetails {
    getFixupPrototypeFunction() { return PatchManagementAwsStatisticsDetails.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementAwsStatisticsDetails>): PatchManagementAwsStatisticsDetails {
        let obj = Object.assign(new PatchManagementAwsStatisticsDetails(), model);
        PatchManagementAwsStatisticsDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementAwsStatisticsDetails>): PatchManagementAwsStatisticsDetails {
        if (!model) return null;
        return PatchManagementAwsStatisticsDetails.newInstance(<PatchManagementAwsStatisticsDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementAwsStatisticsDetails) {
        if (!obj) return;

        models.PatchManagementAwsStatisticsDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementAwsStatisticsDetails): boolean {
        Object.setPrototypeOf(obj, PatchManagementAwsStatisticsDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.installed_count === undefined) {
            this.installed_count = 0;
        }
        if (this.installed_other_count === undefined) {
            this.installed_other_count = 0;
        }
        if (this.installed_pending_reboot_count === undefined) {
            this.installed_pending_reboot_count = 0;
        }
        if (this.installed_rejected_count === undefined) {
            this.installed_rejected_count = 0;
        }
        if (this.missing_count === undefined) {
            this.missing_count = 0;
        }
        if (this.failed_count === undefined) {
            this.failed_count = 0;
        }
        if (this.unreported_not_applicable_count === undefined) {
            this.unreported_not_applicable_count = 0;
        }
        if (this.not_applicable_count === undefined) {
            this.not_applicable_count = 0;
        }
        if (this.critical_non_compliant_count === undefined) {
            this.critical_non_compliant_count = 0;
        }
        if (this.security_non_compliant_count === undefined) {
            this.security_non_compliant_count = 0;
        }
        if (this.other_non_compliant_count === undefined) {
            this.other_non_compliant_count = 0;
        }
    }

    /**
     * Number of patches from the patch baseline that are installed
     */
    installed_count: number;

    /**
     * Number of patches not specified in the patch baseline that are installed
     */
    installed_other_count: number;

    /**
     * Number of patches installed by Patch Manager since the last time the managed node was rebooted
     */
    installed_pending_reboot_count: number;

    /**
     * Number of Rejected Patches count
     */
    installed_rejected_count: number;

    /**
     * Number of patches from the baseline that are applicable for the managed node but not currently installed
     */
    missing_count: number;

    /**
     * Number of patches from the patch baseline that were attempted to be installed during the last patching operation, but failed to install
     */
    failed_count: number;

    /**
     * Number of patches beyond the supported limit of NotApplicableCount that not reported by name to Inventory
     */
    unreported_not_applicable_count: number;

    /**
     * Number of patches from the patch baseline not applicable for the managed node
     */
    not_applicable_count: number;

    /**
     * Number of patches per node that are specified as Critical for compliance reporting in the patch baseline not installed
     */
    critical_non_compliant_count: number;

    /**
     * Number of patches per node that are specified as Security in a patch advisory not installed
     */
    security_non_compliant_count: number;

    /**
     * Number of patches per node that are specified as other than Critical or Security but not  compliant with the patch baseline
     */
    other_non_compliant_count: number;

}
